<template>
  <div class="content">
    <img src="@/assets/img/law_bgg.jpeg" alt="" />
    <div>
      <h1>总则</h1>
      <div class="main">
        <div>
          <span>
            第一条
          </span>
          为了加强对城市房地产的管理，维护房地产市场秩序，保障房地产权利人的合法权益，促进房地产业的健康发展，制定本法。
        </div>
        <div>
          <span>
            第二条
          </span>
          在中华人民共和国城市规划区国有土地（以下简称国有土地）范围内取得房地产开发用地的土地使用权，从事房地产开发、房地产交易，实施房地产管理，应当遵守本法。
          本法所称房屋，是指土地上的房屋等建筑物及构筑物。
          本法所称房地产开发，是指在依据本法取得国有土地使用权的土地上进行基础设施、房屋建设的行为。
          本法所称房地产交易，包括房地产转让、房地产抵押和房屋租赁。
        </div>
        <div>
          <span>
            第三条
          </span>
          国家依法实行国有土地有偿、有限期使用制度。但是，国家在本法规定的范围内划拨国有土地使用权的除外。
        </div>
        <div>
          <span>
            第四条
          </span>
          国家根据社会、经济发展水平，扶持发展居民住宅建设，逐步改善居民的居住条件。
        </div>
        <div>
          <span>
            第五条
          </span>
          房地产权利人应当遵守法律和行政法规，依法纳税。房地产权利人的合法权益受法律保护，任何单位和个人不得侵犯。
        </div>
        <div>
          <span>
            第六条
          </span>
          为了公共利益的需要，国家可以征收国有土地上单位和个人的房屋，并依法给予拆迁补偿，维护被征收人的合法权益；征收个人住宅的，还应当保障被征收人的居住条件。具体办法由国务院规定。
        </div>
        <div>
          <span>
            第七条
          </span>
          国务院建设行政主管部门、土地管理部门依照国务院规定的职权划分，各司其职，密切配合，管理全国房地产工作。县级以上地方人民政府房产管理、土地管理部门的机构设置及其职权由省、自治区、直辖市人民政府确定。
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  data() {
    return {
      maskShow: false,
      href: "",
    };
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="less" scoped>
h1 {
  text-align: center;
  font-size: 0.34rem;
  font-weight: bold;
  padding: 0.4rem 0;
}
.content {
  color: #000;
  position: relative;
  img {
    width: 100%;
    height: 100vh;
    opacity: 0.5;
  }
  & > div {
    position: absolute;
    top: 0;
    z-index: 200;
  }
}
.main {
  div {
    margin-top: 0.2rem;
    padding-left: 0.3rem;
    font-size: 0.28rem;
    line-height: 0.4rem;
    span {
      font-weight: bold;
      font-size: 0.32rem;
    }
  }
}
</style>
